export enum MessageType {
  Error,
  Info,
}



// WEBPACK FOOTER //
// ./src/app/shared/components/message/message-type.ts